var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.25V11.75M8 4.25V11.75M5 8.75V11.75M8 14.75C5.1877 14.75 3.78155 14.75 2.79581 14.0338C2.47745 13.8025 2.19748 13.5225 1.96619 13.2042C1.25 12.2184 1.25 10.8123 1.25 8C1.25 5.1877 1.25 3.78155 1.96619 2.79581C2.19748 2.47745 2.47745 2.19748 2.79581 1.96619C3.78155 1.25 5.1877 1.25 8 1.25C10.8123 1.25 12.2184 1.25 13.2042 1.96619C13.5225 2.19748 13.8025 2.47745 14.0338 2.79581C14.75 3.78155 14.75 5.1877 14.75 8C14.75 10.8123 14.75 12.2184 14.0338 13.2042C13.8025 13.5225 13.5225 13.8025 13.2042 14.0338C12.2184 14.75 10.8123 14.75 8 14.75Z",
    stroke: "#F6F6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOne);
export default __webpack_public_path__ + "static/media/IconOne.53f89388e728e349e4b34752e9f249ec.svg";
export { ForwardRef as ReactComponent };